module.exports = __webpack_public_path__ + "static/media/31.eebb1615.png";